"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashBanner = exports.DashBannerComponent = exports.ROUTES = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const mithril_component_1 = require("../../components/mithril.component");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_1 = require("../page");
const dashboard_style_1 = require("./dashboard.style");
exports.ROUTES = {
    POLE_STATUS: () => services_1.Services.Route.go(page_1.IkePageName.dashboardPolestatus),
    POLE_LOADING: () => services_1.Services.Route.go(page_1.IkePageName.dashboardPoleloading),
    MENU: () => services_1.Services.Route.go(page_1.IkePageName.dashboardMenu),
};
class DashBannerComponent extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        this.name = 'DashBanner';
    }
    get nodes() {
        if (!services_1.Services.User.hasUser) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            services_1.Services.User.logout();
            return null;
        }
        return (0, mithril_1.m)('header', { className: dashboard_style_1.Banner.header.container }, [
            (0, mithril_1.m)('div', { className: dashboard_style_1.Banner.header.row }, [
                (0, mithril_1.m)('div', { className: dashboard_style_1.Banner.header.section }, [
                    //this.viewMenuIcon, #Future overview page
                    this.viewPoleStatusIcon,
                    this.viewPoleLoadingIcon,
                ]),
            ]),
        ]);
    }
    get viewMenuIcon() {
        return (0, mithril_1.m)('div', { className: 'button' }, [
            (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.MENU, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD) }, [
                (0, mithril_1.m)('span', { className: dashboard_style_1.Banner.menuButton.span, onclick: exports.ROUTES.MENU, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD) }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD)),
            ]),
        ]);
    }
    get viewPoleStatusIcon() {
        return (0, mithril_1.m)('div', { className: 'button' }, [
            (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.POLE_STATUS, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS) }, [
                (0, mithril_1.m)('span', {
                    className: services_1.Services.Route.isPoleStatus() ? dashboard_style_1.Banner.menuButton.spanSelected : dashboard_style_1.Banner.menuButton.span,
                    onclick: exports.ROUTES.POLE_STATUS,
                    title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS),
                }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS)),
            ]),
        ]);
    }
    get viewPoleLoadingIcon() {
        return (0, mithril_1.m)('div', { className: 'button' }, [
            (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.POLE_LOADING, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING) }, [
                (0, mithril_1.m)('span', {
                    className: services_1.Services.Route.isPoleLoading() ? dashboard_style_1.Banner.menuButton.spanSelected : dashboard_style_1.Banner.menuButton.span,
                    onclick: exports.ROUTES.POLE_LOADING,
                    title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING),
                }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING)),
            ]),
        ]);
    }
}
exports.DashBannerComponent = DashBannerComponent;
tslib_1.__decorate([
    mobx_1.computed
], DashBannerComponent.prototype, "nodes", null);
exports.DashBanner = new DashBannerComponent();
//# sourceMappingURL=dashboard.banner.js.map